import type { SVGProps } from 'react';

export type FlagESProps = SVGProps<SVGSVGElement> & {
  size?: number;
};

export const FlagES = ({ size = 60, ...rest }: FlagESProps) => (
  <svg
    width={size}
    height={size * (40 / 60)}
    viewBox="0 0 60 40"
    role="img"
    aria-label="Español"
    {...rest}
  >
    <title>Espa&ntilde;ol</title>
    <rect x="1" y="1" width="58" height="9.5" fill="#C8362C" />
    <rect x="1" y="10.5" width="58" height="19" fill="#E8B43C" />
    <rect x="1" y="29.5" width="58" height="9.5" fill="#C8362C" />
    <rect
      x="1"
      y="1"
      width="58"
      height="38"
      fill="none"
      stroke="var(--color-ink)"
      strokeWidth="1.5"
    />
  </svg>
);
